export default __webpack_public_path__ + "static/media/a028-2.393066b1.png";